import { useState, useEffect } from 'react';

const PaginationScroll = (callback, props) => {
    const [radio, setRadio] = useState(null);
    const [isFetching, setIsFetching] = useState(true);

    const intersection = new IntersectionObserver((obs) => {
        const intersectionRatio = obs[0].intersectionRatio;
        setRadio(intersectionRatio);
    });

    useEffect(() => {
        const pagination = document.getElementById('paginationUlInfiniteScroll');

        if (pagination) {
            intersection.observe(pagination);
            return () => intersection.disconnect();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const loading = document.getElementsByClassName('ui text loader')?.length > 0;
        if (radio > 0 && !loading && (props.page > props.current.currentPage + 1)) {
            callback();
        }

        // eslint-disable-next-line
    }, [radio]);

    return [isFetching, setIsFetching];
};

export default PaginationScroll;
